import { TenantMetadata } from "../../domain/TenantSlice/TenantMetadata";
import { JuncosImageHashes } from "./JuncosImageHashes";
import metadataJson from "./TenantMetadata.json";

export const JuncosMetadata = {
  ...metadataJson,
  ImageHashes: JuncosImageHashes,
} as TenantMetadata;